import React, { useEffect, useRef } from 'react';
import { Grid, Typography, Link } from "@mui/material";

const Notifications=()=>{

    const tickerRef = useRef(null);
  

    const notificationList=[
      
      {title:'B.Com.(H). BBA & MBA MTE Improvement April-2026 ',url:'/assets/img/pdf/bcomh_bba_and_mba_mte_improvement_april_2026.pdf' , status:'new'},
      {title:' B.Sc.Biotech. MTE Improvement April-2026',url:'/assets/img/pdf/bscbiotech_mte_improvement_april_2026.pdf' , status:'new'},
      {title:'B.Sc.CS & MCA MTE Improvement April-2026 ',url:'/assets/img/pdf/bsccs_and_mca_mte_improvement_april_2026.pdf' , status:'new'},
      {title:'B.Sc.CVT MTE Improvement April-2026 ',url:'/assets/img/pdf/bsccvt_mte_improvement_april_2026.pdf' , status:'new'},
      {title:'B.Sc.MLT MTE Improvement April-2026 ',url:'/assets/img/pdf/bscmlt_mte_improvement_april_2026.pdf' , status:'new'},
      {title:'B.Tech. MTE Improvement April-2026 ',url:'/assets/img/pdf/btech_mte_improvement_april_2026.pdf' , status:'new'},
      {title:'BA(POL.)Sc. MTE Improvement April-2026 ',url:'/assets/img/pdf/bapolsc_mte_improvement_april_2026.pdf' , status:'new'},
      {title:'BALL.B. MTE Improvement April-2026 ',url:'/assets/img/pdf/ballb_mte_improvement_april_2026.pdf' , status:'new'},
      {title:'BBALL.B. MTE Improvement April-2026 ',url:'/assets/img/pdf/bballb_mte_improvement_april_2026.pdf' , status:'new'},
      {title:' BCA MTE Improvement April-2026',url:'/assets/img/pdf/bca_mte_improvement_april_2026.pdf', status:'new'},
      {title:'DMLT MTE Improvement April-2026 ',url:'/assets/img/pdf/dmlt_mte_improvement_april_2026.pdf', status:'new'},
      {title:'LL.B.& LLM MTE Improvement April-2026 ',url:'/assets/img/pdf/llband_llm_mte_improvement_april_2026.pdf', status:'new'},
      {title:'M.Tech. MTE Improvement April-2026 ',url:'/assets/img/pdf/mtech_mte_improvement_april_2026.pdf', status:'new'}, 
      
      
      {title:'B.Com.(H). BBA & MBA Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/bcomh_bba_and_mba_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'B.Sc.Biotech. Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/bscbiotech_theory_date_sheet_end_term_examinations_april_2026.pdf'}, 
      {title:'B.Sc.CVT Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/bsccvt_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'B.Sc.MLT Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/bscmlt_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'B.Tech. & M.Tech. Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/btech_and_mtech_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'BA(POL.)Sc. Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/bapolsc_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'BALL.B. Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/ballb_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:' BBALL.B. Theory Date Sheet End Term Examinations April-2026',url:'/assets/img/new_images/bballb_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:' BCA,MCA & B.Sc Theory Date Sheet End Term Examinations April-2026',url:'/assets/img/new_images/bcamca_and_bsc_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'DHA Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/dha_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'DMLT Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/dmlt_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'LL.B.& LLM Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/llband_llm_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'M.Sc.M.Bio Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/mscmbio_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'Pharmacy Dept. Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/pharmacy_dept_theory_date_sheet_end_term_examinations_april_2026.pdf'},
      {title:'MMLT Theory Date Sheet End Term Examinations April-2026 ',url:'/assets/img/new_images/mmlt_theory_date_sheet_end_term_examinations_april_2026.pdf'}
        
    ]
 

    useEffect(() => {
        const ticker = tickerRef.current;
        const clone = ticker.cloneNode(true);
        ticker.parentNode.appendChild(clone);

        return () => {
        clone && clone.remove();
        };
    }, []);

    return(
         
        <div className="news-ticker-vertical">
          <div className="ticker-wrap-vertical">
            <div className="ticker-vertical" ref={tickerRef}>
              {notificationList.map((item, index) => (
                <a key={index} href={item.url} className="ticker-item-vertical" target="_blank" rel="noopener noreferrer">
                  
                  {item.status === "new" && (
                    <img
                      src="/assets/img/newanimation.gif" // update path if needed
                      alt="New"
                      className="new-icon"
                      style={{ marginLeft: "8px", width: "20px" }}
                    />
                  )}

                  
                  {item.title}
                </a>
              ))}
            </div>
          </div>
        </div>  
    )
}
export default Notifications;